import React, {PropsWithChildren} from 'react';
import {View, Text} from 'react-native';
import {responsiveWidth} from 'react-native-responsive-dimensions';

import {text} from '../../text';
import {theme} from '../../constants';
import {ReviewType} from '../../types';
import Image from '../custom/Image';
import ReviewStars from '../ReviewStars';

type Props = PropsWithChildren<{
  item: ReviewType;
  last?: boolean;
  containerStyle?: object;
}>;

const ReviewItem: React.FC<Props> = ({
  item,
  containerStyle,
  last,
}): JSX.Element => {
  return (
    <View
      style={{
        backgroundColor: theme.colors.backgroundPrimary,
        width: responsiveWidth(100) - 40 - 28,
        marginRight: last ? 20 : 14,
        borderRadius: 10,
        padding: 20,
        ...containerStyle,
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingBottom: 13,
          borderBottomWidth: 1,
          borderBottomColor: '#E9F3F6',
          marginBottom: 11,
        }}
      >
        {item.avatarUrl ? (
          <Image
            source={{uri: item.avatarUrl}}
            style={{
              width: 30,
              height: 30,
              marginRight: 14,
              borderRadius: 15,
            }}
          />
        ) : (
          <View
            style={{
              width: 30,
              height: 30,
              marginRight: 14,
              borderRadius: 15,
              backgroundColor: '#E9F3F6',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <text.H5>{item.name.charAt(0)}</text.H5>
          </View>
        )}
        <View style={{marginRight: 'auto'}}>
          <text.H5 style={{marginBottom: 4}}>{item.name}</text.H5>
          <ReviewStars rating={item.rating ?? 0} />
        </View>
        <View>
          <Text
            style={{
              ...theme.fonts.DMSans_400Regular,
              fontSize: 10,
              color: theme.colors.textMuted,
              marginBottom: 2,
            }}
          >
            {item.date}
          </Text>
          <Text
            style={{
              textAlign: 'right',
              ...theme.fonts.DMSans_500Medium,
              fontSize: 10,
              lineHeight: 10 * 1.5,
              color: theme.colors.accentPrimary,
            }}
            onPress={() => {}}
          >
            Reply
          </Text>
        </View>
      </View>
      {!!item.comment && <text.T14>{item.comment}</text.T14>}
    </View>
  );
};

export default ReviewItem;
